import React from 'react'
import { SVGIconProps } from '../types'
const SvgSpeedMed = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        stroke="#233745"
        strokeWidth={1.5}
        d="M8 3.15a6.53 6.53 0 0 1 4.631 1.918A6.53 6.53 0 0 1 14.55 9.7c0 1.271-.165 2.253-.553 2.923l-.094.15-4.911.047a2.26 2.26 0 0 0 1.258-2.02c0-.467-.347-2.092-.733-3.507a23 23 0 0 0-.511-1.671 5 5 0 0 0-.22-.523 1.4 1.4 0 0 0-.157-.242c-.176-.212-.227-.614-1.035-.182l-.1.055c-.052.047-.093.09-.28.369-.064.121-.14.3-.22.523a23 23 0 0 0-.511 1.67c-.386 1.416-.733 3.04-.733 3.508a2.24 2.24 0 0 0 1.297 2.039l-4.716.043c-.676-.834-.881-1.863-.881-3.182a6.53 6.53 0 0 1 1.918-4.632A6.53 6.53 0 0 1 8 3.15Zm-4.85 6.5c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121 1.5 1.5 0 0 0-1.06-.439Zm9.7 0c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121 1.5 1.5 0 0 0-1.06-.439Zm-9.1-4.1c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0-.907-2.553Zm8.5 0c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121 1.5 1.5 0 0 0-1.06-.439Z"
      />
    </g>
  </svg>
)
export default SvgSpeedMed
